import type { FaireProductEntity } from "../../entity_types/product";

export const apparel_socks_neutral: FaireProductEntity = {
  token: "apparel-socks-neutral",
  type: "product",
  name: "Neutral Ribbed Socks Set",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/f5a053ed0f279916c27a5cea84ee48b194f750565b3d43eac571bcda0e183bc3.jpeg",
  priceDollars: 8,
  msrpDollars: 18,
  freeShipping: true,
  weight: 0.3,
  dimensions: {
    width: 4,
    height: 2,
    depth: 1,
  },
  description: "Set of 3 ribbed cotton crew socks in earthy neutral tones.",
  categoryTokens: ["cat_accessories"],
  tags: ["apparel", "socks", "neutral", "ribbed"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
